import { init, report } from './main';
import { setCommonParams, setEventParams } from './params';
import { rawReport, getParams } from './report';
import { getPlatform } from './util';
// import {EVENT_NAME, setEventParams} from './params'

export default function (paramCollecters) {
  const platform = getPlatform();
  const bridgeInit = function (params) {
    init({
      paramCollecter: paramCollecters[platform] || ((undefined, callback) => callback({})),
      ...params,
    });
  };
  return {
    init: bridgeInit,
    report,
    getParams,
    rawReport,
    setEventTags: setEventParams,
    setCommonParams,
  };
}
